import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import NavHeader from '../NavHeader';

export const UserSetting = ({
  email,
  enabled,
  settingTitle,
  settingUpdatedText,
  save,
  saveText,
  toggle,
  buttonStyle,
  displaySettingsSavedText,
}) => (
  <div className={styles.settingsDashboard}>
    <NavHeader />
    <div className={styles.settingHeader}>
      <span className={styles.settingTitle}>{settingTitle}</span>
      <button className={styles.button} style={buttonStyle} onClick={save}>
        {saveText}
      </button>
    </div>

    <div className={styles.settingMain}>
      <p className={styles.emailHeader}>NOTIFICATION PREFERENCES</p>

      <div className={styles.emailToggle}>
        <div className={styles.toggle}>
          <label className={styles.switch}>
            <input type="checkbox" checked={enabled} onClick={toggle} />
            <span className={styles.slider} />
          </label>
        </div>

        <div className={styles.description}>
          <p className={styles.emailLabel}>Email</p>
          <p className={styles.email}>{email}</p>
        </div>
      </div>
      {displaySettingsSavedText && (
        <div className={styles.settingUpdate}>{settingUpdatedText}</div>
      )}
    </div>
  </div>
);

export default enhance(UserSetting);
